import React, { ReactNode, ComponentProps, ChangeEvent, RefObject } from "react";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import styles from "src/commun/composants/formulaire/AppInput/AppInput.scss";
import AppIcon from "src/commun/composants/AppIcon";

export type AppInputProps = {
  name: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  error?: string;
  touched?: boolean;
  suffix?: string;
  children?: ReactNode;
  fieldRef?: RefObject<HTMLInputElement>;
  iconVerif?: boolean;
  isRequired?: boolean;
} & ComponentProps<"input">;

const AppInput = ({
  name,
  onChange,
  value,
  error,
  touched,
  children,
  suffix,
  fieldRef,
  iconVerif = false,
  className,
  isRequired = false,
  disabled,
  type = "text",
  ...reste
}: AppInputProps) => {
  const inputComponent = (
    <>
      <input
        className={`${error && touched ? "error" : ""} ${value ? "fill" : ""} ${styles.input} ${disabled && "btn__filter--disabled"} ${className}`}
        name={name}
        ref={fieldRef}
        onChange={onChange}
        value={value ?? ""}
        required={!disabled && isRequired}
        disabled={disabled}
        type={type}
        {...reste}
      >
        {children}
      </input>
    </>
  );

  const getErrorMessage = () => {
    return <>{error && touched && <AppFormErrorMessages erreurs={error} />}</>;
  };

  // s'il y a un suffix, le composant change un peu
  if (suffix) {
    return (
      <>
        <div className={styles.inputSuffix}>
          {inputComponent}
          <div className="d-inline" style={{ paddingLeft: "6px" }}>
            {suffix}
          </div>
          {iconVerif && (
            <AppIcon
              name={touched && !error ? "verification" : ""}
              className={touched && !error ? styles.selectIconVerif : styles.hiddenIconVerif}
              size="32px"
            />
          )}
        </div>
        {getErrorMessage()}
      </>
    );
  } else if (iconVerif) {
    return (
      <>
        <div className={styles.inputSuffix}>
          {inputComponent}{" "}
          {value && (
            <AppIcon
              name={touched && !error ? "verification" : ""}
              className={touched && !error ? styles.selectIconVerif : styles.hiddenIconVerif}
              size="32px"
            />
          )}
        </div>
        {getErrorMessage()}
      </>
    );
  }

  return (
    <React.Fragment>
      {inputComponent}
      {getErrorMessage()}
    </React.Fragment>
  );
};

export default AppInput;
